export default __webpack_public_path__ + "static/visa-card-stack-dc3678f720199f4c0f0d6a9680324a25.png";